import { useEffect } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import {
  SAMPLE_DETAIL_PATH,
  SAMPLE_USAGE_HISTORY_PATH,
  isLegacyNumericSamplePathSegment,
  writeSampleDetailSession,
  writeSampleUsageHistorySession,
} from '../../utils/samplePageNavigation';

function LegacySampleDetailRedirect() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLegacyNumericSamplePathSegment(id)) {
      navigate('/samples', { replace: true });
      return;
    }
    const sampleId = parseInt(id!, 10);
    writeSampleDetailSession({ sampleId });
    navigate(SAMPLE_DETAIL_PATH, {
      replace: true,
      state: { sampleId },
    });
  }, [id, navigate]);

  return <LegacyRedirectSpinner />;
}

function LegacySampleUsageHistoryRedirect() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLegacyNumericSamplePathSegment(id)) {
      navigate('/samples', { replace: true });
      return;
    }
    const sampleId = parseInt(id!, 10);
    writeSampleUsageHistorySession(sampleId);
    navigate(SAMPLE_USAGE_HISTORY_PATH, {
      replace: true,
      state: { usageHistorySampleId: sampleId },
    });
  }, [id, navigate]);

  return <LegacyRedirectSpinner />;
}

function LegacyRedirectSpinner() {
  const { t } = useTranslation();
  return (
    <Container className="mt-4 text-center">
      <Spinner animation="border" role="status">
        <span className="visually-hidden">{t('common.loading')}</span>
      </Spinner>
    </Container>
  );
}

/** 誤ルート /samples/detail/123 等を一覧へ */
export function LegacySampleCatchAllRedirect() {
  return <Navigate to="/samples" replace />;
}

export { LegacySampleDetailRedirect, LegacySampleUsageHistoryRedirect };
